import React from 'react';

import ResourceState, { resourceStateOf } from '../loading/ResourceState';

/**
 * What the shell says when the collection cannot be shown (docs/platform-
 * standards.md §13.2 "States", §14). It is drawn INSIDE the frame, beneath the
 * header, in place of the page: the crumb, the badge and the way back stay where
 * they are, so a person is never dropped onto a bare error screen.
 *
 * The API answers 404 for a collection that does not exist AND for one the
 * person may not open (it never confirms a hidden collection), so the 404
 * wording says both. 403 is a collection that is known and refused. Anything
 * else is a failed read: say so and offer Retry (§14: the error names what
 * failed and offers Retry; never a raw exception message).
 *
 * The panel is the platform's `ResourceState` (components/loading, KPR-1579)
 * with the collection's copy and the way back to All collections; the
 * mapping from a failed read is its `resourceStateOf`.
 */
export function shellStateOf(error) {
	return resourceStateOf(error);
}

const COPY = {
	'not-found': {
		title: 'Collection not found',
		body: 'It may have been deleted, or it isn\'t shared with you.',
	},
	'no-access': {
		title: 'You don\'t have access to this collection',
		body: 'Ask the person who owns it to share it with you.',
	},
	error: {
		title: 'Couldn\'t load this collection',
		body: 'Check your connection and try again.',
	},
};

export default function ShellState({ state, onRetry }) {
	const copy = COPY[state];
	if (!copy) return null;
	return (
		<ResourceState
			state={state}
			title={copy.title}
			body={copy.body}
			backTo="/collections"
			backLabel="All collections"
			onRetry={onRetry}
			className="shell-state"
			data-shell-state-message={state}
		/>
	);
}
